import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  visible,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText,
  cancelBtnClass = '',
  confirmBtnClass = ''
}) => {
  if (!visible) return null;
  const dialogTitleId = 'confirm-modal-title';
  const dialogDescId = 'confirm-modal-desc';

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div
        className="modal-box"
        role="dialog"
        aria-modal="true"
        aria-labelledby={dialogTitleId}
        aria-describedby={dialogDescId}
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
      >
          <h3 id={dialogTitleId} className="modal-title">{title}</h3>
        <p id={dialogDescId} className="modal-message">
          {message}
        </p>
        <div className="modal-actions">
          <button
            type="button"
            className={`modal-cancel-btn ${cancelBtnClass}`.trim()}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`modal-primary-btn ${confirmBtnClass}`.trim()}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 